{
	"address": "Heimilisfang",
	"addressRequired": "Skylda að fylla út",
	"allowedFiles": "Leyfilegar skrár eru: png, jpg, jpeg, gif, bmp, doc, docx, txt og pdf",
	"choose": "Veldu",
	"chooseCountry": "Veldu land",
	"choosePostbox": "Veldu póstbox",
	"city": "Borg",
	"dragFilesHere": "Dragið skrár hingað inn eða ýtið hér til að hlaða upp skrám",
	"electronicId": "Rafræn skilríki",
	"email": "Netfang",
	"emailNotValid": "Netfang er ekki á réttu formi",
	"emailRequired": "Skylda að fylla út",
	"error": "Villa",
	"errorMessage": "Upp kom villa. Vinsamlegast reynið aftur síðar.",
	"fileNotallowed": "Ekki leyfileg skráar ending eða skráin er stærri en 25mb.",
	"file-min": "Verður að bæta við skjali",
	"homeDelivery": "Panta heimsendingu",
	"homeDeliveryInfo": "Við munum gefa þér upp 30 mínútna glugga fyrir áætlaðan afhendingartíma.",
	"infoAboutSender": "Upplýsingar um sendanda",
	"maxNumbers": "Of margir tölustafir",
	"maxText": "Of langur texti",
	"minNumbers": "Of fáir tölustafir",
	"minText": "Of stuttur texti",
	"name": "Nafn",
	"nameRequired": "Skylda að fylla út",
	"newsletterCompanies": "Fá fréttir fyrir fyrirtæki",
	"newsletterShops": "Fá fréttir fyrir netverslanir",
	"newsletterIndividuals": "Fá fréttir fyrir einstaklinga",
	"newsletterRequired": "Verður að velja minnst einn póstlista til að fylgjast með",
	"next": "Næsta skref",
	"onLoad": "...Andartak",
	"onlyNumbers": "Aðeins tölustafir leyfilegir",
	"open-pdf": "Ef pdf skjalið opnast ekki sjálfkrafa, ýttu þá á hlekkinn fyrir neðan til að opna það.",
	"open-pdf-link": "Opna pdf skjal",
	"paymentInfo": "Bankaupplýsingar",
	"phone": "Farsímanúmer",
	"phoneMax": "Símanúmer inniheldur of mörg tákn",
	"phoneMin": "Símanúmerið inniheldur of fáa tölustafi",
	"phoneNotValid": "Símanúmerið er ekki á réttu formi",
	"phoneRequired": "Skylda að fylla út",
	"postboxRequired": "Skylda að fylla út",
	"print-pdf": "Athugaði að prenta fylgiskjal út og látið það fylgja Póstinum við póstlagningu.",
	"required": "Skylda að fylla út",
	"signUp": "Skrá",
	"ssn": "Kennitala",
	"ssn-valid": "Kennitala er ekki rétt - Aðeins tölustafir eru leyfðir, ekkert bil eða bandstrik",
	"submit": "Senda",
	"success": "Aðgerð tókst",
	"successMessage": "Gögn hafa verið móttekin.",
	"successMessagePostboxDelivery1": "Til að við getum gengið frá áframsendingu í Póstbox þarf að millifæra 990 kr. á eftirfarandi reikning:",
	"successMessagePostboxDelivery2": "Kt. 7012966139, Rnr. 116-26-6666",
	"successMessagePostboxDelivery3": "Mikilvægt: Sendu okkur kvittun á posturinn@posturinn.is úr heimbanka og láttu sendingarnúmer viðkomandi sendingar fylgja með í tilvísun.",
	"successMessagePostlist": "Takk fyrir að skrá þig á Póstlista Póstsins - frábært að fá þig í hópinn!",
	"thereWasAnError": "Aðgerð tókst ekki",
	"thereWasAnErrorText": "Búið er að senda póst á kerfisstjóra. Ef að þetta er áríðandi hafðu þá samband við þjónustuver",
	"trackingnumber": "Sendingarnúmer",
	"trackingnumberWrong": "Sendingarnúmer á vitlausu sniði",
	"trackingnumberForeignFormat": "Sendingarnúmer verður að byrja á C eða R til að vera sending erlendis.",
	"trackingnumberMax": "Sendingarnúmer má í mesta lagi vera 35 stafir á lengd",
	"trackingnumberMin": "Sendingarnúmer þarf að vera a.m.k 8 stafir á lengd",
	"trackingnumberNotFound": "Sendingarnúmer finnst ekki",
	"trackingnumberRequired": "Skylda að fylla út",
	"trackingnumberNotOutbound": "Þú getur aðeins sent fyrirspurn um sendingar sem eru sendar úr landi",
	"zip": "Póstnúmer",
	"zipRequired": "Skylda að fylla út",
	"tooLong": "Of margir stafir",
	"must-be-7": "Verður að vera 7 stafir",
	"chatAuth": "Auðkenning í netspjall",
	"chatAuthInfo": "Vinsamlegast auðkenndu þig með rafrænum skilríkjum svo við getum veitt þér betri upplýsingar",
	"enterCommas": "Skráðu kommu á milli ef þú ætlar að skrá fleiri en eitt sendingarnúmer t.d. CD123456789CD,CD123456789CD"
}